module.exports = __webpack_public_path__ + "97de89f4dfad6ef800a5eb04a330716e.pdf";